export default "__VITE_ASSET__3bbadb97__"